import React from 'react';

class CollapsableBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: props.collapsed
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ collapsed: nextProps.collapsed }, function() {
            if (this.props.onToggle)
                this.props.onToggle();
        });
    }
    
    iconClass = () => {
        if (this.state.collapsed)
            return "glyphicon glyphicon-plus";
        else
            return "glyphicon glyphicon-minus";
    }

    toogleBox = () => {
        this.setState({ collapsed: !this.state.collapsed }, function() {
            if (this.props.onToggle)
                this.props.onToggle();
        });
    }

    render() {
        const { title, children, boxStyle = "primary" } = this.props;

        return (
            <React.Fragment>
                <div className={'box box-' + boxStyle + (this.state.collapsed ? ' collapsed-box' : '')}>
                    <div className="box-header with-border" style={{ cursor: "pointer" }} onClick={this.toogleBox}>
                        <h3 className="box-title">
                            {title}
                        </h3>
                        <div className="box-tools pull-right">
                            <button type="button" className="btn btn-box-tool" data-widget="collapse">
                                <i className={this.iconClass()}></i>
                            </button>
                        </div>
                    </div>
                    <div className="box-body">
                        {children}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CollapsableBox;



// WEBPACK FOOTER //
// ./src/fw/components/collapsableBox/CollapsableBox.js